module.exports = __webpack_public_path__ + "img/customer-subnav.44b8c4fb.svg";